export const multipleMasterCampaignsSelected = (checkboxSelections) => {
	const masterCampaigns = checkboxSelections?.selectedMasterCampaigns || [];
	const activationCampaigns = checkboxSelections?.selectedActivationCampaigns || [];
	const allActivationCampaignsHaveMatchingMaster =
		(masterCampaigns.length &&
			activationCampaigns.every((campaign) => {
				return campaign.masterCampaignId === masterCampaigns[0];
			})) ||
		(!masterCampaigns.length &&
			activationCampaigns.every((campaign) => {
				return campaign.masterCampaignId === activationCampaigns[0].masterCampaignId;
			}));
	const moreThanOneMasterCampaign = masterCampaigns?.length > 1;
	return moreThanOneMasterCampaign || !allActivationCampaignsHaveMatchingMaster;
};
